import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-company-setting',
  templateUrl: './company-setting.component.html',
  styleUrls: ['./company-setting.component.scss']
})
export class CompanySettingComponent implements OnInit {

  public setting:any = {};
  public is_save:boolean = false;
  public trim_step_options:string[] = ['1', '5', '10', '50', '100'];
  constructor(private http: HttpService) { 
    this.companySetting();
  }

  ngOnInit(): void {
  }


  async companySetting() {
    let rtn:any = await this.http.post("/admin/company/setting");
    this.setting = rtn.setting;
    // Coerce the stored trim step to a string so it binds to one of the preset
    // dropdown options; fall back to '1' when unset or not in the offered set.
    let step = String(parseFloat(this.setting.withdraw_trim_step));
    this.setting.withdraw_trim_step = this.trim_step_options.indexOf(step) >= 0 ? step : '1';
    // The company override (commission bucket) is stored as a 0–1 fraction (0.3 = 30%)
    // but edited as a percentage. Derive the percent helper the input binds to.
    let bucket = this.setting.agent_company_bucket_rate;
    this.setting.agent_company_bucket_rate_pct =
      (bucket !== '' && bucket != null && !isNaN(parseFloat(bucket)))
        ? String(+(parseFloat(bucket) * 100).toFixed(4))
        : '';
    console.log(this.setting)
  }

  async update() {
    this.is_save = true;
    // Convert the percent input back to the 0–1 fraction the engine expects, and drop
    // the UI-only helper so it is not persisted as a stray setting key.
    let payload:any = { ...this.setting };
    let pct = payload.agent_company_bucket_rate_pct;
    payload.agent_company_bucket_rate =
      (pct === '' || pct == null || isNaN(parseFloat(pct)))
        ? ''
        : String(parseFloat(pct) / 100);
    delete payload.agent_company_bucket_rate_pct;
    let rtn:any = await this.http.post("/admin/company/setting/save", {setting: payload});

    this.is_save = false
  }
}
